/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2023 (original work) Open Assessment Technologies SA
 */

import pageController from '@/core/page/page';
import { selectedInteractions as selectedInteractionsStore } from '@/store/interactions';
import { get } from 'svelte/store';
import { actionsList, routes } from '@/core/utils/consts';
import { postBulkAcs } from '@/core/acs/acs.js';

export default () =>
    // eslint-disable-next-line implicit-arrow-linebreak
    pageController({
        name: 'resume',
        /**
         * Checks if selectedInteractionsStore contains a valid interaction,
         * or redirects to home page if that is not the case
         */
        start() {
            const selected = get(selectedInteractionsStore);
            if (selected.length) {
                // Resume is different from other actions; it has no visual component.
                // It just posts and redirects
                postBulkAcs(actionsList.resume, selected);
            }
            this.router.redirect(routes.home);
        }
    });
